import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
// import Main from './Main';
import { UIRouter } from '@uirouter/react';
import { Provider } from 'react-redux';

import configureStore from './store';

import { router } from './router.config';
import ModalHandlerScreen from './components/ModalHandlerScreen';

const reduxStore = configureStore(window.REDUX_INITIAL_DATA);

const appElement = document.getElementById('insured_portal_security_portlet');

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement(appElement);

class App extends React.Component {
  render() {
    return (
      <Provider store={reduxStore}>
        <UIRouter router={router}>
          <ModalHandlerScreen />
        </UIRouter>
      </Provider>
    );
  }
}

ReactDOM.render(<App />, appElement);
